import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper} from "../../helpers";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImplementationControlStatement} from "../../_models/implementationControlStatement";

@Component({
    standalone: false,
  selector: "select-implementation-control-statement",
  templateUrl: 'select-implementation-control-statement.component.html',
  styleUrls: ['./select-implementation-control-statement.component.scss'],
})
export class SelectImplementationControlStatementComponent implements OnInit {
  implementationControlStatementSets: ImplementationControlStatement[] = [];
  currentUser: User;
  recurringList: any;
  rowGroupMetadata: any;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectImplementationControlStatementComponent>) {
    this.implementationControlStatementSets = data.implementationControlStatementSets;
    this.implementationControlStatementSets.forEach(s => this.updateRowGroupMetaData(s));
  }

  ngOnInit() {
  }
  selectImplementationControlStatement(data)
  {
    this.dialogRef.close(data);
  }

  addToken(html) {
    console.log(html);
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateRowGroupMetaData(set) {
    const data = set.implementationControlStatements;
      this.rowGroupMetadata = this.rowGroupMetadata || {};
    this.rowGroupMetadata[set.id] = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        rowData.category = rowData.category || ' ';
        let brand = rowData.category || ' ';
        if (i == 0) {
          this.rowGroupMetadata[set.id][brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category || ' ';
          if (brand === previousRowGroup)
            this.rowGroupMetadata[set.id][brand].size++;
          else
            this.rowGroupMetadata[set.id][brand] = {index: i, size: 1};
        }
      }
    }
  }

}
